import isEqual from 'lodash/isEqual';
import React, { Component, PropsWithChildren } from 'react';
import { Modal } from '../index';
import { FilterSelection } from './FilterSelection';
import { IFilterModalProps, IFilterValues } from './types';

export interface IFilterModalState {
  values: IFilterValues;
  visible: boolean;
}

export class FilterModal extends Component<PropsWithChildren<IFilterModalProps>, IFilterModalState> {
  public state = {
    values: this.props.values || this.props.initialValues,
    visible: false,
  };
  public handleSelectionChange = (values: IFilterValues) => {
    this.setState({ values });
    this.props.onChange(values);
    this.closeFilterModal();
  };
  public openFilterModal = () => {
    this.setState(() => ({ visible: true }));
  };
  public closeFilterModal = () => {
    this.setState(() => ({ visible: false }));
  };

  public componentDidUpdate(prevProps: IFilterModalProps) {
    if (this.props.values && !isEqual(this.props.values, prevProps.values)) {
      this.setState({ values: this.props.values });
    }
  }
  public render() {
    const { filters } = this.props;
    if (!filters.length) {
      return null;
    }
    const isFiltering = this.props.setIsFiltering
      ? this.props.setIsFiltering(this.state.values)
      : Object.keys(this.state.values).some((key) => !!this.state.values[key]);
    return (
      <div>
        {this.props.render({
          closeFilterModal: this.closeFilterModal,
          isFiltering,
          openFilterModal: this.openFilterModal,
        })}
        <Modal show={this.state.visible} onHide={this.closeFilterModal}>
          <FilterSelection
            filters={filters}
            values={this.state.values}
            onChange={this.handleSelectionChange}
            onCancel={this.closeFilterModal}
          />
        </Modal>
      </div>
    );
  }
}

export default FilterModal;
